<script lang="ts">
    import type {AxiosInstance} from 'axios';
    import {COOKIE_VALUE, TEMPLATE} from 'general/constants';
    import {dyData, modal} from 'general/store';

    import FlipItem from 'desktop/components/flipItem/FlipItem.svelte';
    import Theme from 'general/theme/Theme.svelte';
    import CloseButton from 'general/components/closeButton/CloseButton.svelte';
    import Description from 'general/components/description/Description.svelte';
    import QrSteps from '../helpers/qrSteps/QrSteps.svelte';
    import QrCode from 'desktop/components/qrcode/QrCode.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import {setCookie} from 'general/libs/setCookie';

    import s from './style.module.css';

    export let instance: AxiosInstance;

    const onQrButtonClick = () => {
        setCookie(COOKIE_VALUE.SUBSCRIBER_PHONE, 'true', 365);
        modal.close();
    };
</script>

<FlipItem>
    <Theme template={TEMPLATE.CIRCLE} color={$dyData.side.typ.backgroundColor}>
        <div class={s.subscribed} style="margin-top: {$dyData.side.typ.marginTop || 0}">
            <CloseButton handleClick={modal.close} theme="dark" />
            <Description value={$dyData.description?.typ} />
            <QrSteps />
            <QrCode
                {instance}
                text={$dyData.qrCode?.typ?.text}
                size={$dyData.qrCode?.typ?.size}
                marginBottom={$dyData.qrCode?.typ?.marginBottom}
                marginTop={$dyData.qrCode?.typ?.marginTop}
            />
            <ActionButton
                handleClick={onQrButtonClick}
                color="dodgerBlue"
                marginTop="8px"
                fontSize="22px"
                fontWeight="700"
                lineHeight="30px"
                children="Got it"
                {...$dyData.actionButton?.typ || {}}
            />
        </div>
    </Theme>
</FlipItem>
